import useEvent from 'react-use/lib/useEvent';

export const useKey = (key: string, handler: () => void) => {
  useEvent('keydown', (evt: KeyboardEvent) => {
    if (evt.key === key) {
      handler();
    }
  });
};
